import { matchRoute, type Routes, type Query } from '@atlassian/jira-router';
import { filtersDirectoryRoute } from '@atlassian/jira-router-routes-directories-routes';
import {
	globalIssueNavigatorRoute,
	globalIssueNavigatorBrowseIssueRedirectRoute,
} from '@atlassian/jira-router-routes-issue-navigator-routes';
import { legacyGinSubscriptionsRoute } from '@atlassian/jira-router-routes-legacy-gin-subscriptions-routes';

type RoutePredicate = (path: string, query: Query) => boolean;

// Return a predicate that will return `true` if the provided router match matches any of the defined routes.
const getMatchRoutePredicate =
	(...routes: Routes): RoutePredicate =>
	(path: string, query: Query): boolean =>
		matchRoute(routes, path, query) !== null;

// Return true if the provided router match matches any of the provided route predicates.
export const matchesAnyRoute = (path: string, query: Query, ...predicates: RoutePredicate[]) =>
	predicates.some((predicate) => predicate(path, query));

// Routes used to view issues associated with an individual filter. This includes GIN (`/issues`) and legacy GIN
// (`/browse/:issueKey/?[jql|filter]`) routes.
export const viewIssuesMatcher = getMatchRoutePredicate(
	globalIssueNavigatorRoute,
	globalIssueNavigatorBrowseIssueRedirectRoute,
);

// Routes used to manage subscriptions for an individual filter.
export const filterSubscriptionMatcher = getMatchRoutePredicate(legacyGinSubscriptionsRoute);

// Routes used to view all filters
export const viewFiltersMatcher = getMatchRoutePredicate(filtersDirectoryRoute);
